import React from 'react';
import useCartCleanup from '../store/cart/CartCleanup';

const CartCleanupWrapper: React.FC = () => {
  useCartCleanup(); 

  return null; 
};

export default CartCleanupWrapper;
